<template>
  <div class="at-home__wrapper">
    <p class="at-home__title">Installation essentials</p>
    <p class="at-home__text">
      Please confirm you understand and agree to the following:
    </p>
    <div class="at-home__container">
      <Checkbox
        v-for="(confirmation, key) in confirmations"
        :key="key"
        v-model="confirmation.value"
        :input-id="confirmation + '-' + key"
        :label="confirmation.text"
        checkbox-card
        full-width
        data-testid="confirmation-checkbox"
        :data-testkey="key"
      />
      <AppButton
        class="at-home__next-button"
        :disabled="!validated"
        data-testid="continue-button"
        @click="nextStep"
      >
        <span> Continue </span>
        <span class="at-home__icon icon icon-arrow-right" />
      </AppButton>
    </div>
  </div>
</template>

<script>
import Checkbox from "@soenergy/frontend-library/src/components/Checkbox.vue"
import AppButton from "@soenergy/frontend-library/src/components/AppButton.vue"

export default {
  components: {
    Checkbox,
    AppButton,
  },
  emits: ["go-forward"],
  computed: {
    confirmations() {
      return this.$store.state.confirmationList
    },
    validated() {
      return this.confirmations.every((confirmation) => confirmation.value)
    },
  },

  methods: {
    nextStep() {
      this.$emit("go-forward")
    },
  },
}
</script>

<style lang="scss" scoped>
.at-home {
  font-size: $font-size-4;
  &__wrapper {
    margin-bottom: $space-12;
    ::v-deep .form-group__input-group {
      max-width: 100%;
    }
  }
  &__icon {
    margin-left: $space-1;
  }
  &__title {
    font-size: $font-size-5;
    font-weight: $weight-medium;
    margin-bottom: $space-2;

    @include md {
      font-size: $font-size-6;
    }
  }

  &__text {
    font-size: $font-size-3;
    margin-bottom: $space-8;

    @include md {
      font-size: $font-size-4;
    }
  }
  &__container {
    display: flex;
    flex-direction: column;
    gap: $font-size-4;

    &-text {
      font-size: $font-size-3;
    }
  }

  &__next-button {
    width: 100%;
    margin-top: $space-4;

    @include md {
      margin-bottom: $space-4;
    }
  }
}

::v-deep .checkbox__input:checked + .checkbox__label {
  font-weight: $weight-normal;
}
::v-deep .accordion__heading h4 {
  font-size: $font-size-5;
  font-weight: $weight-medium;
}
</style>
